import apiClient from './apiClient.js';

export const login = (email, password) =>
  apiClient.post('/auth/login', { email, password }).then((r) => r.data.data);

export const me = () => apiClient.get('/auth/me').then((r) => r.data.data);

export default { login, me };
